import React, { useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/login.css';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function LoginPage({ onSuccess }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [touched, setTouched] = useState({ email: false, password: false });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const errors = useMemo(() => {
    const errs = {};
    if (!email) errs.email = 'Email is required';
    else if (!emailRegex.test(email)) errs.email = 'Enter a valid email';
    if (!password) errs.password = 'Password is required';
    else if (password.length < 6) errs.password = 'At least 6 characters';
    return errs;
  }, [email, password]);

  const hasErrors = Object.keys(errors).length > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({ email: true, password: true });
    if (hasErrors) return;
    setSubmitting(true);
    setError('');
    try {
      await login(email, password);
      onSuccess?.();
    } catch (err) {
      setError('Invalid credentials');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-root">
      <div className="login-card">
        <div className="login-left" aria-hidden>
          <img src="./images/licensed-image.jpeg" alt="Logistics background" className="login-img" />
          <div className="overlay" />
          <div className="brand">Truck Delivery</div>
        </div>
        <div className="login-right">
          <form className="form" onSubmit={handleSubmit} noValidate>
            <h2 className="title">Welcome back</h2>
            <p className="subtitle">Please sign in to continue</p>

            <div className={`field ${touched.email && errors.email ? 'invalid' : ''}`}>
              <label htmlFor="email">Email</label>
              <input id="email" type="email" placeholder="name@example.com" value={email} onChange={(e) => setEmail(e.target.value)} onBlur={() => setTouched((t) => ({ ...t, email: true }))} autoComplete="email" />
              {touched.email && errors.email && <div className="hint">{errors.email}</div>}
            </div>

            <div className={`field ${touched.password && errors.password ? 'invalid' : ''}`}>
              <label htmlFor="password">Password</label>
              <input id="password" type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} onBlur={() => setTouched((t) => ({ ...t, password: true }))} autoComplete="current-password" />
              {touched.password && errors.password && <div className="hint">{errors.password}</div>}
            </div>

            {error && <div className="form-error" role="alert">{error}</div>}

            <button className="submit" type="submit" disabled={submitting || hasErrors}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}